import actionConstants from '../constants/';

const validationErrorState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  message: '',
  validationErrors: {
    //  Note: All the new validation error messages
    //  will be added here and then will be transferred to API
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again',
    ACCOUNT_IS_BLOCKED: 'This account is blocked',
    TRM_STATUS_UPDATE_SUCCESS: 'TRM status updated successfully',
    TRM_STATUS_UPDATE_FAILURE: 'TRM status change failed',
    PASSWORD_EXPIRED: 'Your Password is expired.',
    LDAP_USER_NOT_FOUND: 'Request Admin For Access',
    PAN_INVALID: 'PAN entered is invalid. Please enter valid PAN details.',
    PASSWORD_EXPIRY_WARNING:
      'Your password will expire in ${passwordExpireDays} days',
    INCORRECT_OTP: 'Incorrect OTP',
    PASSWORD_CHANGED: 'Password changed successfully.',
    SIGNUP_SUCCESS: 'Signup was successful.',
    RESEND_EMAIL_SUCCESS: 'Email resent successfully.',
    REQUIRED_FIELD: 'This is a required field',
    PAYMENT_LINK_DATE_TIME_RANGE:
      'Payment link schedule time should be earlier than link expiry time',
    PAYMENT_LINK_CREATED_SUCCESSFULLY: 'Payment link created successfully',
    PAYMENT_LINK_UPDATED_SUCCESSFULLY:
      'Payment link ${paymentLinkId} updated successfully',
    REFUND_INITIATE_SUCCESS_DESCRIPTION:
      'Refund has been initiated for Transaction ID ${transactionId}',
    REFUND_INITIATE_SUCCESS: 'Refund Initiated',
    TOKEN_EXPIRED: 'Token expired',
    PASSWORD_SAVED: 'Password saved successfully.',
    STATUS_UPDATED_SUCCESSFULLY: 'Status Updated Successfully!',
    STATUS_UPDATED_SUCCESSFULLY_DESCRIPTION:
      'Your status has been updated successfully.',
    REQUEST_NOT_PROCESSED:
      'Your request could not be processed. Please try later.',
    FETCHING_GATEWAYS_FAILED: 'Fetching Gateways Failed',
    GATEWAY_CREATED_SUCCESSFULLY: 'Gateway Created Successfully!',
    GATEWAY_CREATED_SUCCESSFULLY_DESCRIPTION:
      'Payment Gateway ID ${gatewayId} was created successfully',
    GATEWAY_CREATION_FAILED: 'Gateway Creation Failed!',
    GATEWAY_UPDATED_SUCCESSFULLY: 'Gateway Updated Successfully!',
    GATEWAY_UPDATED_SUCCESSFULLY_DESCRIPTION:
      'Payment Gateway ID ${gatewayId} was updated successfully',
    GATEWAY_UPDATE_FAILED: 'Gateway Updation Failed!',
    SMART_ROUTING_BIN_ROUTE_DELETE: 'Bin Routing Deleted',
    SMART_ROUTING_BIN_ROUTE_DELETE_DESCRIPTION:
      'Bin Route was deleted successfully',
    SMART_ROUTING_BRAND_ROUTE_DELETE: 'Brand Routing Deleted',
    SMART_ROUTING_BRAND_ROUTE_DELETE_DESCRIPTION:
      'Card Brand Routing was deleted successfully',
    SMART_ROUTING_ISSUER_ROUTE_DELETE: 'Issuer Routing Deleted',
    SMART_ROUTING_ISSUER_ROUTE_DELETE_DESCRIPTION:
      'Issuer Route was deleted successfully',
    SMART_ROUTING_BIN_ROUTING_CREATED_SUCCESS: 'Bin Routing Created',
    SMART_ROUTING_BIN_ROUTING_CREATED_SUCCESS_DESCRIPTION:
      'Bin Route was created successfully',
    SMART_ROUTING_BIN_ROUTING_CREATED_FAILURE: 'Bin Routing Creation Failed',
    SMART_ROUTING_BIN_ROUTING_UPDATED_SUCCESS: 'Bin Routing Updated',
    SMART_ROUTING_BIN_ROUTING_UPDATED_SUCCESS_DESCRIPTION:
      'Bin Route was updated successfully',
    SMART_ROUTING_BRAND_ROUTING_CREATED_SUCCESS: 'Brand Routing Created',
    SMART_ROUTING_BRAND_ROUTING_CREATED_SUCCESS_DESCRIPTION:
      'Card Brand Routing was created successfully',
    SMART_ROUTING_BRAND_ROUTING_CREATED_FAILURE:
      'Brand Routing Creation Failed',
    SMART_ROUTING_BRAND_ROUTING_UPDATED_SUCCESS: 'Brand Routing Updated',
    SMART_ROUTING_BRAND_ROUTING_UPDATED_SUCCESS_DESCRIPTION:
      'Card Brand Routing was updated successfully',
    SMART_ROUTING_ISSUER_ROUTING_CREATED_SUCCESS: 'Issuer Routing Created',
    SMART_ROUTING_ISSUER_ROUTING_CREATED_SUCCESS_DESCRIPTION:
      'Issuer Route was created successfully',
    SMART_ROUTING_ISSUER_ROUTING_CREATED_FAILURE:
      'Issuer Routing Creation Failed',
    SMART_ROUTING_ISSUER_ROUTING_UPDATED_SUCCESS: 'Issuer Routing Updated',
    SMART_ROUTING_ISSUER_ROUTING_UPDATED_SUCCESS_DESCRIPTION:
      'Issuer Route was updated successfully',
    SMART_ROUTING_PRIORITY_LOGIC_UPDATE_SUCCESS: 'Priority Logic Updated',
    SMART_ROUTING_PRIORITY_LOGIC_UPDATE_SUCCESS_DESCRIPTION:
      'Priority Logic was updated succesfully.',
    SMART_ROUTING_FETCHING_ACTIVE_PRIORITY_LOGIC_FAILED:
      'Fetching Active Priority Logic Failed',
    SMART_ROUTING_PRIORITY_LOGIC_DELETE_SUCCESS: 'Priority Logic Deleted',
    SMART_ROUTING_PRIORITY_LOGIC_DELETE_SUCCESS_DESCRIPTION:
      'Priority Logic was deleted succesfully.',
    SMART_ROUTING_PRIORITY_LOGIC_DELETE_FAILED:
      'Priority Logic Deletion Failed',
    RECORDS_UPLOADED_SUCCESSFULLY: 'Records Uploaded Successfully',
    INVALID_FILE_TYPE_CSV:
      '${fileName} is not a valid file type. Please choose a csv file.',
    INVALID_FILE_NAME:
      'File Name should contain alphabets, numbers, hyphen or underscore only.',
    EMAIL_ADDRESS_OR_PASSWORD_IS_INCORRECT:
      'Please ensure your email and password are correct.',
    LOGIN_FAILED: 'Login failed',
    PAYMENT_LINK_EXPIRY_DATE_TIME_VALIDATION:
      'Link expiry time should greater than current time',
    SMART_ROUTING_PREFERENCE_MAPPING_ALREADY_EXISTS:
      'Preference score mapping already exists',
    MAX_DATE_RANGE_MESSAGE: 'Date range cannot exceed 3 months',
    TOKEN_NOT_VALID: 'Token is no longer valid',
    PASSWORD_ALREADY_SET: 'Password is already set for your account',
    PREVIOUS_LINK_STILL_VALID: 'Previous link is still valid',
    INVALID_REQUEST: 'Request is invalid',
    CAPTCHA_LOADING_FAILED:
      'Please check your internet connection and reload to get a reCAPTCHA challenge.',
    RESEND_OTP: 'Please try resending OTP',
    USER_IS_TERMINATED: 'User is terminated, please reset your password',
    INCORRECT_VERIFICATION_CODE:
      'This doesn’t match the Code we sent. Check again?',
    INCORRECT_VERIFICATION_CODE_FOR_FIVE_TIMES:
      'You have entered incorrect code for 5 times. Please resend code!',
    MAX_OTP_ATTEMPTS_LIMIT_REACHED:
      'You have exceeded maximum limit of resend OTP, please try after 24 hours.',
    MAX_RESET_PASSWORD_LIMIT_REACHED:
      'You can reset your password only thrice in 24 hours. Please try again later.',
    LOGIN_OTP_EXPIRED: 'Verification code is expired, Please resend code!',
    IFSC_CODE_MAX_LENGTH: 'IFSC code can not be more than 11 char',
    ACCOUNT_NO_MAX_LENGTH: 'Account no can not be more than 32 char',
    ACCOUNT_NUMBER_MIN_LENGTH:
      'Account number cannot be less than 10 characters',
    ONLY_ALPHANUMERIC_ALLOWED: 'Only alphanumeric are allowed',
    BANK_NAME_MAX_LENGTH: 'Bank name can not be more than 50 char',
    ACCOUNT_NAME_MAX_LENGTH: 'Account name can not be more than 64 char',
    ONLY_ALPHABETS_ALLOWED: 'Only Alphabets are allowed',
    BENEFICIARY_ALREADY_DISABLED: 'Beneficiary already disabled',
    BENEFICIARY_NOT_FOUND: 'Beneficiary not found',
    EMPTY_LABEL_NAME: 'Empty label name found',
    DUPLICATE_LABEL_NAME: 'Duplicate label name found',
    SAVED_SUCCESSFULLY: 'Saved Successfully!',
    SUCCESS: 'SUCCESS',
    ACCOUNT_NO_MATCH_ERROR: 'Both account no. need to be same',
    INVALID_EMAIL: 'Invalid Email',
    INVALID_REMARK: 'Invalid Remark',
    INVALID_NAME: 'Invalid Name',
    INVALID_URL: 'Invalid URL',
    ACCOUNT_NUMBER_MISMATCH: "Account Number doesn't match",
    INVALID_PHONE_NUMBER: 'Invalid Phone Number',
    INVALID_BENEFICIARY_NAME: 'Invalid Beneficiary Name',
    INVALID_IFSC_CODE: 'Invalid code IFSC',
    BENEFICIARY_ALREADY_FAILED: 'Beneficiary has already been failed',
    INVALID_UPI_ID: 'Invalid UPI ID',
    INVALID_PAN: 'Invalid PAN',
    BENEFICIARY_IN_PENDING_STATUS: 'Beneficiary is in pending status',
    BENEFICIARY_IN_VALIDATING_STATUS: 'Beneficiary is in validating status',
    TRANSACTION_IN_REFUND_STATE_IMEI_BLOCKING_NOT_ALLOWED:
      'Transaction in refund state imei blocking not allowed',
    IMEI_TRANSACTION_NOT_CAPTURED: 'Imei transaction not captured',
    IMEI_TRANSACTION_IN_CAPTURED_STATE: 'IMEI TRANSACTION IN CAPTURED STATE',
    IMEI_NUMBER_ALREADY_UNBLOCKED: 'imei number already unblocked',
    INTERNAL_SERVER_ERROR: 'internal server error',
    INVALID_PARAMS: 'Request is invalid',
    GIVEN_IMEI_NUMBER_IS_ALREADY_BLOCKED:
      'Given imei number is already blocked',
    GIVEN_IMEI_NUMBER_IS_PENDING_FROM_ANOTHER_TRANSACTION_ID:
      'Given imei number is pending from another transaction id',
    PRODUCT_CODE_NOT_ALLOWED_TO_BLOCK_PROVIDED_IMEI:
      'Product code not allowed to block provided imei',
    TRANSACTION_IN_CAPTURED_STATE_SHOULD_BE_REFUNDED_TO_UNBLOCK_IMEI:
      'Transaction in captured state should be refunded to unblock imei',
    TRANSACTION_IS_NOT_CAPTURED_YET: 'Transaction is not captured yet',
    IMEI_BLOCK_FAILED: 'IMEI Block failed',
    IMEI_UNBLOCK_FAILED: 'IMEI Unblock failed',
    TPV_UPDATE_SUCCESS: 'TPV updated successfully',
    TPV_UPDATE_FAILURE: 'TPV change failed',
    SUBSCRIPTION_UPDATE_SUCCESS: 'Subscription updated successfully',
    SUBSCRIPTION_UPDATE_FAILURE: 'Subscription change failed',
    EMAIL_TEMPLATE_UPDATED: 'Email Template Updated',
    ISSUANCE_EMAIL_SUCCESS: 'Issuance email template is successfully updated',
    HALFWAY_EMAIL_SUCCESS:
      'Halfway reminder email template is successfully updated',
    FINAL_EMAIL_SUCCESS:
      'Final reminder email template is successfully updated',
    PAYMENTLINK_EMAIL_SUCCESS:
      'Payment link email template is successfully updated',

    EMAIL_GREETING_REQUIRED: 'Email greeting can’t be blank.',
    EMAIL_SUBJECT_REQUIRED: 'Email subject can’t be blank.',
    REFUND_AMOUNT_SHOULD_BE_GREATER_THAN_EQUAL_TO_INR_1:
      'Refund amount cannot be less than ₹1',
    REMAINING_AUTH_AMOUNT_SHOULD_BE_GREATER_THAN_EQUAL_TO_INR_1:
      'Remaining auth amount after refund can not be less than ₹1',
    INVALID_GSTIN: 'Entered GSTIN value in not valid.',
    INVALID_SUBJECT: 'Enter Valid Subject',
    INVALID_DESC: 'Enter Valid Description',
    MPR_REPORT_MAXIMUM_DATE_RANGE_ERROR:
      'You can only retrieve a maximum of 7 days MPR report at once',
    DOWNLOAD_FILE_MORE_THAN_EXPECTED_RECORD:
      'The number of records are too large. Please narrow your search criteria.',
    FAILED_TO_GENERATE_LINK:
      'Failed to create payment link, please try generating a new link',
    INVOICE_NUMBER_ALREADY_EXISTS:
      'Invoice number already exists. Please enter a unique number.',
    DESCRIPTIOM_MAX_LENGTH_ERROR:
      'Description is too long. Please shorten it & try again.',
    PAST_DATE_TIME_ERROR: 'Date time cannot be in the past',
    EMAIL_NOT_VALID: 'Enter a valid email with letters, numbers, and a proper domain',
    NAME_INVALID: 'Only letters, spaces, dots, hyphens, or apostrophes allowed',
  },
};

const initialState = {
  validationErrorState: { ...validationErrorState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function validationReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.POST_VALIDATION_ERRORS_REQUEST:
      return {
        ...state,
        validationErrorState: {
          ...state.validationErrorState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          message: '',
        },
      };

    case actionConstants.POST_VALIDATION_ERRORS_SUCCESS:
      return {
        ...state,
        validationErrorState: {
          ...state.validationErrorState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          validationErrors: {
            ...state.validationErrorState.validationErrors,
            ...action.payload.body,
          },
          opCode: 0,
          message: '',
        },
      };

    case actionConstants.POST_VALIDATION_ERRORS_FAILURE:
      return {
        ...state,
        validationErrorState: {
          ...state.validationErrorState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload?.body?.error_code || 0,
          message: action.payload?.body?.error_message || '',
        },
      };

    case actionConstants.POST_VALIDATION_ERRORS_CLEAR:
      return {
        ...state,
        validationErrorState,
      };
    default:
      return state;
  }
}
